import { Box, Chip, IconButton, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { withSnackbar } from '../../../../utils/SnackbarHOC';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import { displaySwipeableDrawerSummaryCandidat } from '../../../../redux/SwipeableDrawer/actions/swipeableDrawerActions';
import { useDispatch } from 'react-redux';
import ShowAddCvCandidat from '../../../Candidat/VisualiserCandidat/ShowAddCvCandidat';
import AppointmentModal from '../../../Candidat/VisualiserCandidat/Tabs/Modals/CandidatProcess/AppointmentModal';
import EmailModal from '../../../../components/EmailModal/EmailModal';
import { sendEmailCandidat } from '../../../../services/ProcessService.js';
import { TABLE } from '../../../../enums/tablesEnum.js';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Reporting interne');

const stepColors = {
  'Non validée': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  'Embauche': { bg: '#f0fdf4', color: '#166534', border: '#86efac' },
  'Integration': { bg: '#ecfdf5', color: '#065f46', border: '#6ee7b7' },
  'REFUSÉ PAR CLIENT': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'REFUSÉ PAR CANDIDAT': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'Refusé par client': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'Refusé par candidat': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'Refusé par Go&Dev': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'No show': { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' },
  'RV CLOSING': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  'RV CLIENT': { bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
  'ENVOI CLIENT': { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
  'TEST INTERNE': { bg: '#faf5ff', color: '#7c3aed', border: '#e9d5ff' },
  'Préqualif RH': { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
};

function getStepLabel(row) {
  const expectedStatus = ['Non validée', 'Embauche', 'Integration', 'REFUSÉ PAR CLIENT', 'REFUSÉ PAR CANDIDAT', 'Refusé par client', 'Refusé par candidat', 'Refusé par Go&Dev', 'No show'];
  const { step, testInterne, sent, rvClient, rvClosing } = row;
  if (expectedStatus.includes(step)) return step;
  if (rvClosing) return 'RV CLOSING';
  if (rvClient) return 'RV CLIENT';
  if (sent) return 'ENVOI CLIENT';
  if (testInterne) return 'TEST INTERNE';
  return 'Préqualif RH';
}

const getLastNameOnly = (row = {}) => {
  const prenomValue = String(row.prenom || '').trim();
  const nomValue = String(row.nom || '').trim();
  if (prenomValue && nomValue.toLowerCase().startsWith(prenomValue.toLowerCase())) {
    return nomValue.slice(prenomValue.length).trim() || nomValue;
  }
  return nomValue || '—';
};

const fmtDate = (v) => v != null ? moment(new Date(v)).format('DD/MM/YYYY') : '—';

const TableReportingIntern = ({ reportingData, setReportingData, snackbarShowMessage, reloadData, setReloadData }) => {
  const dispatch = useDispatch();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
  const isMediumMode = useMediaQuery((theme) => theme.breakpoints.between(767, 1023));
  const [messageType, setMessageType] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [prenom, setPrenom] = useState();
  const [email, setEmail] = useState();
  const [idCandidat, setIdCandidat] = useState();

  const handleOpenModal = () => setOpenModal(true);

  const columns = [
    {
      field: 'numCandidat', headerName: 'N° CANDIDAT', width: 130,
      renderCell: (p) => {
        const row = p.row;
        const candidatName = `${row.prenom || ''} ${getLastNameOnly(row)}`.trim();
        return (
          <ShowAddCvCandidat snackbarShowMessage={snackbarShowMessage} files={row.uploadedFiles || []} fileName={candidatName}>
            {p.value}
          </ShowAddCvCandidat>
        );
      },
    },
    {
      field: 'nom', headerName: 'NOM', width: 160, valueGetter: (value, row) => getLastNameOnly(row),
      renderCell: (p) => {
        const lastName = getLastNameOnly(p.row);
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden' }}>
            {!(isSmall || isMediumMode) && (
              <IconButton size="small" onClick={() => dispatch(displaySwipeableDrawerSummaryCandidat({ show: true, id: p.row.id }))}
                sx={{ color: '#03407b', p: 0.25 }}>
                <RemoveRedEye sx={{ fontSize: 15 }} />
              </IconButton>
            )}
            <Link to={`/candidats/${p.row.id}/view`} style={{ textDecoration: 'none', color: '#0f172a', fontWeight: 600, fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {lastName}
            </Link>
          </Box>
        );
      },
    },
    {
      field: 'prenom', headerName: 'PRÉNOM', width: 130,
      renderCell: (p) => (
        <Link to={`/candidats/${p.row.id}/view`} style={{ textDecoration: 'none', color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Link>
      ),
    },
    {
      field: 'sourceur', headerName: 'SOURCEUR', width: 140,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'consultant', headerName: 'TALENT MANAGER', width: 160,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'manager', headerName: 'DELIVERY MANAGER', width: 170,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'client', headerName: 'CLIENT', width: 160,
      renderCell: (p) => p.value ? (
        <Link to={`/societe/${p.row.client_id}/view`} style={{ textDecoration: 'none', color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value}
        </Link>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'nom_mission', headerName: 'MISSION', width: 200,
      renderCell: (p) => p.value ? (
        <Link to={`/societe/${p.row.client_id}/missions/${p.row.uuid}/view`} style={{ textDecoration: 'none', color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value}
        </Link>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'priorite', headerName: 'PRIORITÉ', width: 140,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'step', headerName: 'STEP', width: 160, valueGetter: (value, row) => getStepLabel(row),
      renderCell: (p) => {
        const label = getStepLabel(p.row);
        const cfg = stepColors[label] || { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' };
        return (
          <Chip label={label} size="small"
            sx={{ background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`, fontWeight: 600, fontSize: '1rem', height: 22, borderRadius: '6px' }} />
        );
      },
    },
    {
      field: 'dateAccrochage', headerName: 'PREQUALIF RH', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{fmtDate(p.value)}</Typography>,
    },
    {
      field: 'testInterne', headerName: 'TEST INTERNE', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{fmtDate(p.value)}</Typography>,
    },
    {
      field: 'testeur', headerName: 'TESTEUR', width: 140,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'sent', headerName: 'ENVOI CLIENT', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{fmtDate(p.value)}</Typography>,
    },
    {
      field: 'rvClient', headerName: 'RV CLIENT', width: 120,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{fmtDate(p.value)}</Typography>,
    },
    {
      field: 'rvClosing', headerName: 'RV CLOSING', width: 120,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{fmtDate(p.value)}</Typography>,
    },
    {
      field: 'dateEmbauche', headerName: 'EMBAUCHE', width: 120,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569' }}>
          {p.value && moment(new Date(p.value)).isValid() ? moment(new Date(p.value)).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'dateIntegration', headerName: 'INTÉGRATION', width: 120,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569' }}>
          {p.value && moment(new Date(p.value)).isValid() ? moment(new Date(p.value)).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'issue', headerName: 'ISSUE', width: 130, sortable: false,
      renderCell: (p) => {
        const row = p.row;
        return (
          <Box>
            <AppointmentModal
              processId={row.idProcess}
              reloadData={reloadData}
              setReloadData={setReloadData}
              snackbarShowMessage={snackbarShowMessage}
              handleOpenModal={handleOpenModal}
              setCandidatInfo={() => { setPrenom(row.prenom); setEmail(row.email); setIdCandidat(row.id); }}
              setMessageType={setMessageType}
            />
          </Box>
        );
      },
    },
  ];

  const rows = (reportingData?.data || []).map((row) => ({
    ...row,
    sent: row.sent?.date != null ? moment(row.sent.date).toDate().getTime() : null,
    // TEST INTERNE = date of the test technique (Process client), old rvTech as fallback
    testInterne: (row.testTechniqueAt?.date || row.rvTech?.date) ? moment(row.testTechniqueAt?.date || row.rvTech.date).toDate().getTime() : null,
    rvClient: row.rvClient?.date != null ? moment(row.rvClient.date).toDate().getTime() : null,
    rvClosing: row.rvClosing?.date != null ? moment(row.rvClosing.date).toDate().getTime() : null,
    dateAccrochage: row.dateAccrochage?.date != null ? moment(row.dateAccrochage.date).toDate().getTime() : null,
  }));

  return (
    <>
      <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: 'calc(100vh - 280px)', minHeight: 400, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          loading={reportingData?.isLoading}
          pageSizeOptions={[10, 30, 50]}
          disableRowSelectionOnClick
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
          localeText={gridLocaleText}
          sx={commonGridSx}
        />
      </Box>
      <EmailModal
        loadData={reloadData}
        setLoadData={setReloadData}
        showButton={false}
        prenom={prenom}
        emailTarget={email}
        serviceEmail={sendEmailCandidat}
        id={idCandidat}
        category={TABLE.CANDIDAT}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleOpenModal={handleOpenModal}
        messageType={messageType}
      />
    </>
  );
};

export default withSnackbar(TableReportingIntern);

